/*eslint-disable*/
import moment from 'moment-timezone';
import { createColumnHelper } from '@tanstack/react-table';
import { ActionData, ActionsTypes, Option, UserDetails } from '../constants/telosair-interfaces';
import { ROLE_BY_ID } from '../constants/global-constants';
import DropdownCustom from '../controls/DropdownCustom';

const options: Option<ActionsTypes>[] = [
  { name: 'Edit user', id: 'edit' },
  { name: 'Delete user', id: 'delete' },
  { name: 'Resend Invite', id: 'resend-invite' }
];

const columnHelper = createColumnHelper<
  UserDetails & { action: (action: ActionData<UserDetails>) => void }
>();

export const UserTableColumns = [
  columnHelper.accessor('id', {
    cell: (info) => info.getValue(),
    header: () => <span>Serial No</span>
  }),
  columnHelper.accessor('firstName', {
    cell: ({ row }) => (
      <div>
        <div> {row.original.firstName}</div>
        <div className="text-gray-500 text-xs ">{row.original.userName}</div>
      </div>
    ),
    header: () => <span>User</span>
  }),
  columnHelper.accessor((row) => row.role, {
    id: 'role',
    cell: (info) => <i>{ROLE_BY_ID[info.getValue()] ?? '-'}</i>,
    header: () => <span>Role</span>
  }),
  columnHelper.accessor('lastActive', {
    header: () => 'Last Active',
    cell: (info) => {
      const renderValue = info.renderValue();
      if (renderValue != null) {
        return moment(renderValue).tz('America/New_York').format('YYYY/MM/DD');
      } else {
        return '-';
      }
    }
  }),
  columnHelper.accessor('action', {
    header: () => <span>Action</span>,
    cell: (row: any) => {
      return (
        <DropdownCustom<ActionsTypes>
          onClick={(type) =>
            row?.row?.original?.action({
              type,
              data: row?.row?.original
            })
          }
          controlPlaceholder="Action"
          buttons={options}
        />
      );
    }
  })
];
/*eslint-disable*/
